// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/element_ui.js';
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
router.beforeEach(async (to,form,next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  next()
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js